// notify/index.js

import { debounce } from 'lodash';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const debouncedToast = debounce((message,type) => {
  if (Array.isArray(message)) {
    message.forEach((message) => {
      toast?.[type](message, { position: "bottom-right" });
    });
  } else {
    toast?.[type](message, { position: "bottom-right" });
  }
}, 300); // 300ms debounce delay


export function info(children, autoClose) {
  return debouncedToast(children, "info");
}

export function success(children, autoClose) {
  return debouncedToast(children, "success");
}

export function warning(children, autoClose) {
  return debouncedToast(children, "warning");
}

export function error(children, autoClose) {
  return debouncedToast(children, "error");
}
